<template>
    <div class="modal avatar-list">
        <div class="wrapper">
            <IconClose class="close" @click="closeModal"></IconClose>

            <p class="login__title">Wybierz obrazek profilowy</p>

            <div class="avatar-list__carousel" v-if="slides && slides.length">
                <carousel>
                    <slide v-for="(items, index) in slides" :key="index">
                        <div class="avatar-list__carousel-item" v-if="items && items.length">
                            <div 
                                v-for="item in items" :key="item.id"
                                class="avatar-list__img" 
                                :class="{'selected': selectedAvatar.id === item.id, 'active': activeAvatar === item.id }" 
                                @click="selectAvatar(item)"
                            >
                                <img :src="item.url"/>
                            </div>
                        </div>
                    </slide>

                    <template #addons="{ slidesCount }">
                        <navigation v-if="slidesCount > 1" />
                    </template>
                </carousel>
            </div>

            <button class="btn" @click="saveAvatar"><span>Akceptuj</span></button>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { parseImageUrl } from '../../mixins/useParseImage';
import IconClose from "../elements/icons/IconClose.vue";
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import { useToast } from "vue-toastification";
const toast = useToast()

import 'vue3-carousel/dist/carousel.css';

export default {
    name: "ProfileAvatarList",
    components: {
        IconClose,
        Carousel,
        Slide,
        Navigation
    },
    mixins: [parseImageUrl],
    props: {
        isChange: {
            type: Boolean,
            default: false,
        },
        activeAvatar: {
            type: Number
        }
    },
    data() {
        return {
            AVATARS: '/api/krainaabc/partial/avatar/list?device=www',
            avatarsList: [],
            slides: [],
            selectedAvatar: ''
        };
    },
    methods: {
        setSlides() {
            if(this.avatarsList && this.avatarsList.length) {
                if(window.innerWidth < 768) {
                    this.slides = this.spliceIntoChunks(this.avatarsList, 6);
                } else {
                    this.slides = this.spliceIntoChunks(this.avatarsList, 8);
                }
            }
        },
        closeModal() {
            this.$emit("closeModal");
        },
        spliceIntoChunks(arr, chunkSize) {
            const res = [];
            while (arr.length > 0) {
                const chunk = arr.splice(0, chunkSize);
                res.push(chunk);
            }
            return res;
        },
        selectAvatar(avatar) {
            if(this.selectedAvatar === avatar.id) {
                this.selectedAvatar = '';
                this.avatars.find((item) => {
                    if(item.id === avatar.id) {
                        item.selected = false;
                    }
                });
            } else {
                this.selectedAvatar = avatar;

                this.avatarsList.find((item) => {
                    if(item.id === avatar.id) {
                        item.selected = true;
                    } else {
                        item.selected = false;
                    }
                });
            }
        },
        getAvatars() {
            axios.get(`${this.AVATARS}`).then((response) => {
                if (response.status === 200) {
                    if(response.data.data && response.data.data.items) {
                        response.data.data.items.forEach((item) => {
                            this.avatarsList.push({
                                id: item._id,
                                url: this.getImg(item.url),
                                title: item.title,
                                selected: false
                            })
                        })
                        this.setSlides();
                    }
                }
            });
        },
        saveAvatar() {
            if(this.selectedAvatar) {
                this.$store.dispatch("changeNewProfileStep", 1);
                this.$store.dispatch("changeSelectedAvatar", this.selectedAvatar);

                if(this.isChange) {
                    this.closeModal();
                } else {
                    this.closeModal();
                    this.$router.push({
                        name: 'ProfileNew',
                        path: '/nowy-profil',
                    });
                }
            } else {
                toast.error("Wybierz awatar");
            }
        },
        getImg(url) {
            if (url) {
                url = parseImageUrl(url,151,151);
            }
            return url;
        },
    },
    mounted() {
        this.getAvatars();
        window.addEventListener('resize', this.setSlides);
    }
};
</script>